module.exports = __webpack_public_path__ + "fonts/fa-solid-900.7fb1cdd9.eot";